const routeMain = () => "/notFoundPage";

export default routeMain;
